import { useSlots, computed } from "vue";
import "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as useDisabledProp } from "./assets/index-DKxr0Yto.js";
import { u as usePlacementProp, X as XDropdown } from "./assets/XDropdown-Bc_0Fycm.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { X as XIcon } from "./assets/XIcon-U9bwokTN.js";
import BasicContent from "./BasicContent.js";
import AdvancedContent from "./AdvancedContent.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "./assets/index-4vIud5LZ.js";
import "@floating-ui/dom";
import "@fortawesome/vue-fontawesome";
import "./ContentBox.js";
import "./CloseButton.js";
const xTooltip = "_xTooltip_1dfkh_1";
const xTooltipActivator = "_xTooltipActivator_1dfkh_5";
const activatorIcon = "_activatorIcon_1dfkh_8";
const style0 = {
  xTooltip,
  xTooltipActivator,
  activatorIcon
};
const { createDisabledProp } = useDisabledProp();
const { createPlacementProp } = usePlacementProp();
const { createTestIdProp } = useDataTestIdProp();
const __default__ = {
  name: "XTooltip",
  components: { BasicContent, AdvancedContent },
  inheritAttrs: true
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    advanced: {
      type: Boolean,
      default: false
    },
    openByHover: {
      type: Boolean,
      default: true
    },
    ...createPlacementProp(),
    ...createDisabledProp(),
    ...createTestIdProp(),
    ...AdvancedContent.props
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    function useAdvancedContent() {
      const isOpenByHover2 = computed(() => props.closeButton ? false : props.openByHover);
      return {
        isOpenByHover: isOpenByHover2
      };
    }
    function getBasicContentProps() {
      const { closeButton, dataTestid } = props;
      return {
        closeButton,
        dataTestid
      };
    }
    function getAdvancedContentProps() {
      const { title, imageSrc, imageAlt } = props;
      return {
        title,
        imageSrc,
        imageAlt,
        ...getBasicContentProps()
      };
    }
    const contentProps = computed(() => {
      if (props.advanced) {
        return getAdvancedContentProps();
      }
      return getBasicContentProps();
    });
    const contentType = computed(() => props.advanced ? "AdvancedContent" : "BasicContent");
    const closeOnClickOutside = computed(() => !props.closeButton);
    const { isOpenByHover } = useAdvancedContent();
    return { __sfc: true, createDisabledProp, createPlacementProp, createTestIdProp, slots, props, useAdvancedContent, getBasicContentProps, getAdvancedContentProps, contentProps, contentType, closeOnClickOutside, isOpenByHover, XDropdown, XIcon };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.XDropdown, { class: _vm.$style.xTooltip, attrs: { "is-open": _vm.isOpen, "open-by-hover": _setup.isOpenByHover, "close-on-click-content": false, "close-on-click-outside": _setup.closeOnClickOutside, "show-arrow": "", "arrow-color": "var(--color-neutral-900)", "disabled": _vm.disabled, "placement": _vm.placement, "data-testid": _vm.dataTestid }, scopedSlots: _vm._u([{ key: "activator", fn: function({ isVisible, on }) {
    return [_c("div", { class: _vm.$style.xTooltipActivator, attrs: { "aria-disabled": _vm.disabled }, on: { "click": on } }, [_vm._t("activator", function() {
      return [_c(_setup.XIcon, { class: _vm.$style.activatorIcon, attrs: { "icon": "question-circle" } })];
    }, { "isVisible": isVisible })], 2)];
  } }, { key: "default", fn: function({ close }) {
    return [_c(_setup.contentType, _vm._b({ tag: "component", on: { "close": close }, scopedSlots: _vm._u([_vm._l(_setup.slots, function(_, name) {
      return { key: name, fn: function() {
        return [_vm._t(name)];
      }, proxy: true };
    })], null, true) }, "component", _setup.contentProps, false))];
  } }], null, true) });
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XTooltip = __component__.exports;
export {
  XTooltip as default
};
